import DateHelpers from '../../helpers/date-helpers';
import ProspectingHelpers from '../../helpers/prospecting-helpers';
import ProspectActivityType from '@/Mapper/ProspectActivityType';
import { ProspectActivityActionTypeId, ProspectActivityActorTypeId } from '@/Mapper/ProspectActivityActionType';

const prospectStore = (apiServices => ({
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    prospect: null,
    stages: [],
    status: [],
    activities: { data: [], loading: true },
    reminders: [],
    notes: [],
    rating: null,
  },
  mutations: {
    setProspect: (state, Obj) => {
      state.prospect = Obj; // eslint-disable-line no-param-reassign
    },
    setProspectActivities: (state, Obj) => {
      state.activities = Obj; // eslint-disable-line no-param-reassign
    },
    setProspectStages: (state, Obj) => {
      state.stages = Obj; // eslint-disable-line no-param-reassign
    },
    setProspectStatus: (state, Obj) => {
      state.status = Obj; // eslint-disable-line no-param-reassign
    },
    setProspectReminders: (state, Obj) => {
      state.reminders = Obj; // eslint-disable-line no-param-reassign
    },
    setProspectNotes: (state, Obj) => {
      state.notes = Obj; // eslint-disable-line no-param-reassign
    },
    setProspectRating: (state, Obj) => {
      state.rating = Obj; // eslint-disable-line no-param-reassign
    },
  },
  actions: {
    async loadProspect(context, payload) {
      return apiServices.pp.prospect.getByKey(payload.prospectKey)
        .then((prospectData) => {
          context.commit('setProspect', prospectData);
          console.log('load prospect');
        }, (err) => {
        // reject(err);
          console.error(err);
        });
    },
    async loadProspectActivities(context, payload) {
      context.commit('setProspectActivities', { data: [], loading: true });

      return apiServices.pp.activity.getProspectActivity(payload.contactKey, payload.prospectKey)
        .then((activityData) => {
          // Add agent image where when userID is available
          activityData.map((activity) => {
            const data = activity;
            if (activity.data.creatorUserId === this.state.agentStore.agent.userid) {
              data.data.avatarImageUrl = this.state.agentStore.agent.imageurl;
            }

            if (activity.data.creatorActorType
              && (activity.data.creatorActorType.activityActorTypeId
                === ProspectActivityActorTypeId.oaConsultant)) {
              data.data.avatarImageUrl = 'oaConsultant';
            }

            data.dateFormatted = DateHelpers.convertFromUTC(activity.date, 'D MMM, YYYY HH:mm');
            return data;
          });

          // Duplicate propertyEstimate to create timeframeAndRelationship ActivtiyActionType
          const findpropertyEstimate = activityData.filter(activity => (
            activity.prospectActivityTypeId === ProspectActivityType.prospect
                || activity.prospectActivityTypeId === ProspectActivityType.contact)
              && activity.data.actionType.activityActionTypeId
                === ProspectActivityActionTypeId.propertyEstimate).map(activity => ({
            ...activity,
            data: {
              ...activity.data,
              actionType: {
                activityActionTypeId: 0,
                type: 'Timeframe & Relationship',
              },
            },
          }));

          // Combine all activites
          const allActivites = activityData.concat(findpropertyEstimate);

          const prospectActivities = {
            data: allActivites.sort((a, b) => new Date(b.date) - new Date(a.date)),
            loading: false,
          };

          context.commit('setProspectActivities', prospectActivities);

          // Activity Type stages = 3
          const stages = activityData.filter(data => data.prospectActivityTypeId
              === ProspectActivityType.stageChange)
            .map(data => data.data)
            .sort((a, b) => new Date(b.date) - new Date(a.date));
          context.commit('setProspectStages', stages);

          // Activity type status = 4
          const status = activityData.filter(data => data.prospectActivityTypeId
              === ProspectActivityType.statusChange)
            .map(data => data.data)
            .sort((a, b) => new Date(b.date) - new Date(a.date));
          context.commit('setProspectStatus', status);

          // Activity type reminder = 5
          const reminders = activityData.filter(data => data.prospectActivityTypeId
            === ProspectActivityType.reminder)
            .map(data => data.data)
            .sort((a, b) => new Date(b.date) - new Date(a.date));
          context.commit('setProspectReminders', reminders);

          // Activity type note = 6
          const notes = activityData.filter(data => data.prospectActivityTypeId
            === ProspectActivityType.note)
            .map(data => data.data)
            .sort((a, b) => new Date(b.date) - new Date(a.date));
          context.commit('setProspectNotes', notes);
        }, (err) => {
          // reject(err);
          console.log(err);
        });
    },
    updateReminder(context, payload) {
      return apiServices.pp.prospect.updateReminder(payload).then((updatedReminder) => {
        const activityList = this.state.prospectStore.activities.data;
        context.commit('setProspectActivities', { data: [], loading: true });

        const findReminder = this.state.prospectStore.reminders
          .find(reminder => reminder.id === updatedReminder.id);

        const prospectsStorePayload = {
          updatedReminder,
          prospect: this.state.prospectStore.prospect,
        };
        this.dispatch('prospectsStore/updateProspectReminderInList', prospectsStorePayload);

        Promise.all([
          findReminder.completedDate = updatedReminder.completedDate,
        ]).then(() => {
          context.commit('setProspectActivities', { data: activityList, loading: false });
        });
      });
    },
    createReminder(context, payload) {
      return apiServices.pp.prospect.createReminder(payload).then((newReminder) => {
        // Add new reminder to exsisting reminders array
        this.state.prospectStore.reminders.push(newReminder);
        // Sort reminders desending
        this.state.prospectStore.reminders
          .sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));

        const newActivity = {
          data: newReminder,
          prospectActivityTypeId: ProspectActivityType.reminder,
        };

        context.dispatch('addActivity', newActivity);

        const prospectsStorePayload = {
          newReminder,
          prospect: this.state.prospectStore.prospect,
        };
        this.dispatch('prospectsStore/updateProspectReminderInList', prospectsStorePayload);
      });
    },
    createStage(context, payload) {
      return apiServices.pp.prospect.createStage(payload).then((newStage) => {
        // Update active stage in prospect object
        // Add new stage to exsisting stages array
        this.state.prospectStore.stages.push(newStage);
        // Sort status desending
        this.state.prospectStore.stages.sort((a, b) => new Date(b.createdDate)
          - new Date(a.createdDate));

        const prospectsStorePayload = {
          newStage,
          prospect: this.state.prospectStore.prospect,
        };

        this.dispatch('prospectsStore/updateProspectStageInList', prospectsStorePayload);

        if (this.state.prospectStore.prospect) {
          this.state.prospectStore.prospect.stage = newStage;
        }

        const newActivity = {
          data: newStage,
          prospectActivityTypeId: ProspectActivityType.stageChange,
        };

        context.dispatch('addActivity', newActivity);
      });
    },
    createStatus(context, payload) {
      return apiServices.pp.prospect.createStatus(payload).then((newStatus) => {
        this.state.prospectStore.status.push(newStatus);
        // Sort status desending
        this.state.prospectStore.status
          .sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));

        const prospectsStorePayload = {
          newStatus,
          prospect: payload.prospect || this.state.prospectStore.prospect,
        };

        this.dispatch('prospectsStore/updateProspectStatusInList', prospectsStorePayload);

        // Update active status in prospect object
        if (this.state.prospectStore.prospect) {
          this.state.prospectStore.prospect.status = newStatus;
        }

        const newActivity = {
          data: newStatus,
          prospectActivityTypeId: ProspectActivityType.statusChange,
        };

        context.dispatch('addActivity', newActivity);
      });
    },
    addActivity(context, payload) {
      if (this.state.prospectStore.activities.data) {
        const activityList = {
          data: this.state.prospectStore.activities.data,
          loading: false,
        };
        context.commit('setProspectActivities', { data: [], loading: true });

        const newActivity = {
          ...payload,
          date: payload.data.createdDate,
          dateFormatted: DateHelpers.formatDateNormal(payload.data.createdDate, 'D MMM, YYYY HH:mm'),
        };

        newActivity.data.avatarImageUrl = payload.data.creatorUserId
      === this.state.agentStore.agent.userid ? this.state.agentStore.agent.imageurl : null;

        Promise.all([
          activityList.data.push(newActivity),
          activityList.data.sort((a, b) => new Date(b.date) - new Date(a.date)),
        ]).then(() => {
          context.commit('setProspectActivities', activityList);
        });
      }
    },
    createContactRating(context, payload) {
      return apiServices.pp.contact.createContactRating(payload).then((rating) => {
        context.commit('setProspectRating', rating);       
      });
    },
    updateContactRating(context, payload) {
      return apiServices.pp.contact.updateContactRating(payload).then((rating) => {
        context.commit('setProspectRating', rating);  
      });
    },
  },
  getters: {
    activteReminder: state => ProspectingHelpers.getProspectsActivteReminder(state.reminders),
    topActivity: (state) => {
      if (state.activities.data.length > 0 && !state.activities.loading) {
        // Filter only contact and prospect activties
        const activities = state.activities.data.filter(activity => activity.prospectActivityTypeId
          === ProspectActivityType.contact
        || activity.prospectActivityTypeId === ProspectActivityType.prospect)
          .map(activity => activity.data);

        return ProspectingHelpers.getProspectsTopActivity(activities);
      }
      return null;
    },
  },
}));

export default prospectStore;
